<template>
    <div :key="item.id + item.timestamp" class="vrm-temperature">
        <span
            v-for="label in labelWords"
            :key="item.id + item.timestamp + label"
            class="vrm-temperature-label"
        >
            {{ label }}
        </span>
        <span class="vrm-temperature-value">
            {{ item.temperatureFormatted }}
        </span>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AngularDirective, ngInject } from '@/vue/decorators/angular-interop';

@Component
@AngularDirective('vrm-tank')
export default class VrmTemperature extends Vue {
    @ngInject()
    locale;

    @Prop()
    item;

    @Prop({ type: Number, default: 0 })
    threshold;

    @Prop({ type: Boolean, required: true })
    detailMode;

    constLabelMax = 8; // const

    get labelWords() {
        let listOfWords = this.item.typeLabel.split(' ');

        let listOfWordsReview = [];
        listOfWords.some(word => {
            if (word.length > this.constLabelMax) {
                // if bigger then 9 chars than add the "..."" and hide the rest
                listOfWordsReview.push(word.slice(0, 6) + '...');
                return true; // break
            }
            listOfWordsReview.push(word);
            return false; // continuo
        });

        // only shows the first three words
        if (listOfWordsReview.length > 3) {
            listOfWordsReview = listOfWordsReview.slice(0, 3);
            listOfWordsReview[2] =
                listOfWordsReview[2].length > this.constLabelMax - 4 // four char for " ..."
                    ? listOfWordsReview[2].slice(0, 4) + '...' // the word is too big to have " ..."
                    : listOfWordsReview[2] + ' ...';
        }
        return listOfWordsReview;
    }
}
</script>
